import React from 'react'
import { isMobile } from 'react-device-detect'
import classNames from 'classnames'

import { HeaderDesktop, HeaderMobile } from './header/index'
import { useAuthHeader } from '../../hooks/header/useAuthHeader'

const Header: React.FC = () => {
  const { currentPath } = useAuthHeader()

  if (currentPath.includes('anonymous')) return <></>
  return (
    <div
      className={classNames(
        'border-gray w-[100%] border-b border-[#D9DEE8] bg-white',
        {
          'mb-[30px]':
            currentPath !== '/my-page' &&
            currentPath !== '/challenge' &&
            !currentPath.includes('ai-studio') &&
            !isMobile,
          'mb-6':
            currentPath !== '/my-page' &&
            currentPath !== '/challenge' &&
            !currentPath.includes('ai-studio') &&
            isMobile,
          'mb-[24px]': currentPath === '/my-page',
          'mb-0':
            currentPath === '/challenge' || currentPath.includes('ai-studio'),
          'fixed top-0 z-50': !isMobile,
        },
      )}
    >
      <header onMouseLeave={() => {}}>
        {isMobile ? <HeaderMobile /> : <HeaderDesktop />}
      </header>
    </div>
  )
}

export default Header
